/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.1
 */

import styled from 'styled-components';

import { WidgetBlockStyled } from '../../styled/WidgetContainerStyled';
import { IWidgetStyled } from '../../widgetTypes';

export const WidgetVotingContainerStyled = styled(WidgetBlockStyled).attrs((props: IWidgetStyled) => ({
    className: `widget__widget-voting ${props.isLoading ? 'widget__widget-voting_loading' : ''}`,
}))`
    position: relative;
    
    & .widget-voting__btn, & .widget-voting__btn button {
        width: 100%;
    }
    
    & .widget-voting__close {
        margin-top: -5px;
        cursor: pointer;
    }
    
    & .widget-voting__text {
        line-height: 1.6;
    }
`;
